import { render, staticRenderFns } from "./LIcon.vue?vue&type=template&id=ee19abb6&scoped=true"
import script from "./LIcon.vue?vue&type=script&lang=js"
export * from "./LIcon.vue?vue&type=script&lang=js"
import style0 from "./LIcon.vue?vue&type=style&index=0&id=ee19abb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee19abb6",
  null
  
)

export default component.exports